export const hasUniqueValues = (array: string[]) => new Set(array).size !== array.length;
